import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from './utils';
export default function FieldLabel({ className, style, children }) {
    return (_jsx("label", { className: classNames('block text-sm font-medium leading-6 text-gray-900', className), style: style, children: children }));
}
